"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = require("babel-runtime/core-js/promise");

var _promise2 = _interopRequireDefault(_promise);

var _env = require("../../utils/env");

var _env2 = _interopRequireDefault(_env);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var axios = require('axios');

var MAXRETRIES = 3;
var RETRYINTERVALS = [5000, 10000, 15000];
var refreshTokenRequestTime = new Date(2018, 11);
var isRefreshing = false;
var failedQueue = [];

var delay = function delay(t) {
  return new _promise2.default(function (resolve) {
    return setTimeout(resolve, t);
  });
};

var processQueue = function processQueue(error) {
  var token = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  failedQueue.forEach(function (prom) {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
};

var HttpService = function HttpService($http, AuthService, $q) {
  "ngInject";

  axios.interceptors.request.use(function (config) {
    if (!config.retries) config.retries = 0;
    return config;
  }, function (error) {
    return _promise2.default.reject(error);
  });

  axios.interceptors.response.use(function (response) {
    return response;
  }, function (error) {
    var originalRequest = error.config;

    if (error.response && error.response.status === 401 && !originalRequest.url.endsWith('refreshtoken') && !originalRequest._retry) {

      if (isRefreshing) {
        return new _promise2.default(function (resolve, reject) {
          failedQueue.push({ resolve: resolve, reject: reject });
        }).then(function (token) {
          originalRequest.headers.Authorization = "Bearer " + token;
          return axios.request(originalRequest);
        }).catch(function (err) {
          return _promise2.default.reject(err);
        });
      }

      originalRequest._retry = true;
      isRefreshing = true;

      if (AuthService.getRefreshToken()) {
        return AuthService.refreshToken().then(function () {
          var newToken = AuthService.getAccessToken();
          originalRequest.headers.Authorization = "Bearer " + newToken;
          processQueue(null, newToken);
          isRefreshing = false;
          return axios.request(originalRequest);
        }).catch(function (err) {
          processQueue(err, null);
          isRefreshing = false;
          AuthService.logout();
          return _promise2.default.reject(err);
        });
      }
    }
    return _promise2.default.reject(error);
  });

  // const refreshToken = () => {
  //   const payload = {
  //     refreshToken: AuthService.getRefreshToken()
  //   };

  //   return axios({
  //     method: "POST",
  //     url: env.getApiUrl("identity/refreshtoken"),
  //     data: payload
  //   })
  //   .then((response) => {
  //     AuthService.setAccessToken(response);

  //     return response;
  //   });
  // };

  var get = function get(path, successCallback, errorCallback) {
    console.log("Get called::", path);

    axios({
      method: "GET",
      url: _env2.default.getApiUrl(path),
      headers: {
        "Authorization": "Bearer " + AuthService.getAccessToken()
      }
    }).then(successCallback).catch(errorCallback);

    // $http({
    //   method: "GET",
    //   url: env.getApiUrl(path),
    //   headers: {
    //     "Authorization": `Bearer ${AuthService.getAccessToken()}`
    //   },
    // })
    // .then(successCallback, (error) => {
    //   if (error.status === 401 && !error.config.url.endsWith('refreshtoken')) {
    //     AuthService.refreshToken().then(() => {
    //       return get(path, successCallback, errorCallback);
    //     }).catch(errorCallback);
    //   }
    // });
  };

  var post = function post(path, payload, successCallback, errorCallback) {
    console.log("Post called::", path, payload);

    $http({
      method: "POST",
      url: _env2.default.getApiUrl(path),
      data: payload,
      headers: {
        "Authorization": "Bearer " + AuthService.getAccessToken()
      }
    }).then(successCallback, function (error) {
      if (error.status === 401 && !error.config.url.endsWith('refreshtoken')) {
        AuthService.refreshToken().then(function () {
          return post(path, payload, successCallback, errorCallback);
        }).catch(errorCallback);
      } else {
        if (errorCallback) {
          errorCallback(error);
        }
      }
    });
  };

  var patch = function patch(path, payload, successCallback, errorCallback) {
    console.log("Patch called::", path, payload);

    $http({
      method: "PATCH",
      url: _env2.default.getApiUrl(path),
      data: payload,
      headers: {
        "Authorization": "Bearer " + AuthService.getAccessToken()
      }
    }).then(successCallback, function (error) {
      if (error.status === 401 && !error.config.url.endsWith('refreshtoken')) {
        AuthService.refreshToken().then(function () {
          return patch(path, payload, successCallback, errorCallback);
        }).catch(errorCallback);
      } else {
        if (errorCallback) {
          errorCallback(error);
        }
      }
    });
  };

  var deleteResource = function deleteResource(path, successCallback, errorCallback) {
    console.log("Delete called::", path);

    $http({
      method: "DELETE",
      url: _env2.default.getApiUrl(path),
      headers: {
        "Authorization": "Bearer " + AuthService.getAccessToken()
      }
    }).then(successCallback, function (error) {
      if (error.status === 401 && !error.config.url.endsWith('refreshtoken')) {
        AuthService.refreshToken().then(function () {
          return deleteResource(path, successCallback, errorCallback);
        }).catch(errorCallback);
      } else {
        errorCallback(error);
      }
    });
  };

  var getPromise = function getPromise(path) {
    console.log("Get promise called::", path);

    var deferred = $q.defer();

    axios({
      method: "GET",
      url: _env2.default.getApiUrl(path),
      headers: {
        "Authorization": "Bearer " + AuthService.getAccessToken()
      }
    }).then(function (response) {
      deferred.resolve(response.data);
    }, function (error) {
      deferred.reject(error);
    });

    return deferred.promise;
  };

  return { get: get, post: post, patch: patch, getPromise: getPromise, deleteResource: deleteResource };
};

exports.default = HttpService;


/** WEBPACK FOOTER **
 ** ./client/app/common/services/http.service.js
 **/